export const NFTCover = ({ cover, style = {}, ...props }: { cover?: string, style?: any, [x: string]: any }): JSX.Element => {
  const videoFormats = ['mov', 'mp4']
  if (cover === '' || cover === undefined) return <></>
  const styles = {
    border: '1px solid #FFFFFF',
    borderRadius: 10,
    ...style
  }
  if (videoFormats.includes(cover.substring(cover.length - 3))) {
    return (<video src={cover} style={styles} controls loop {...props} />)
  }
  return (<img alt="example" src={cover} style={styles} {...props} />)
}
